<h4 class="mb-5">Edit Inventory Settings</h4>
<div mat-dialog-content class="mt-3">
	<mat-form-field class="col-xl-3 col-md-10">
		<mat-label class="text-danger font-weight-bold">Empty</mat-label>
		<input matInput placeholder="10" [(ngModel)]="data.empty_lvl" min="0" max="{{data.low_lvl}}" type="number">
		<span matSuffix class="font-weight-bold">&nbsp; %</span>
	</mat-form-field>
	<mat-form-field class="col-xl-3 col-md-10">
		<mat-label class="text-warning font-weight-bold">Low</mat-label>
		<input matInput placeholder="20" [(ngModel)]="data.low_lvl" min="{{data.empty_lvl}}" max="100" type="number">
		<span matSuffix class="font-weight-bold">&nbsp; %</span>
	</mat-form-field>
	<!-- <mat-form-field class="col-xl-3 col-md-10">
		<mat-label class="text-danger font-weight-bold">Remaining</mat-label>
		<input matInput placeholder="10" [(ngModel)]="data.rem_lvl" min="0" max="100" type="number">
		<span matSuffix class="font-weight-bold">&nbsp; %</span>
	</mat-form-field> -->
	<!-- <mat-form-field class="col-xl-3 col-md-10">
		<mat-label class="text-success font-weight-bold">Can Size</mat-label>
		<input matInput placeholder="150" [(ngModel)]="data.par" min="{{data.low_lvl}}" max="{{data.par}}" type="number">
		<span matSuffix class="font-weight-bold">&nbsp; grams</span>
	</mat-form-field> -->
</div>
<div mat-dialog-actions class="mt-3">
	<div class="col-lg-12 text-right">
		<button type="button" class="ml-auto mr-3" mat-raised-button [mat-dialog-close]="" cdkFocusInitial>
			Close
		</button>
		<button type="button" class="mr-3" color="primary" mat-raised-button [mat-dialog-close]="data" cdkFocusInitial>
			Submit
		</button>
	</div>
</div>
